import { MeasurementInstructionContainer } from '../containers/MeasurementInstructionContainer/index'

export const MeasurementInstructionPage = () => (
    <MeasurementInstructionContainer/>
)